<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<h2>{{title}}</h2>
<p-table #pt [value]="features" (onEditComplete)="onEditComplete($event)" dataKey="featureId" sortMode="multiple"
  selectionMode="single" [(selection)]="feature" [loading]="formLoading" styleClass="p-datatable-striped"
  [ngStyle]="{'width': 'auto'}" [resizableColumns]="true" [autoLayout]="true" [responsive]="true">


  <div class="d-block text-end justify-content-between align-items-center">
    <h1 style="float: left;margin: 6px;">Features</h1>
    <span>
      <!--clear filters-->
      <button pButton pRipple class="p-button-text"
        style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
      (click)="reloadPage()">Clear Filters</button>
    </span>
  </div>
  <ng-template pTemplate="header">
    <tr>
      <th [pSortableColumn]="'featureId'">
        <p-sortIcon [field]="'featureId'"></p-sortIcon>Id
      </th>

      <th>Map
      </th>

      <th [pSortableColumn]="'status'">
        <p-sortIcon [field]="'status'"></p-sortIcon>Status
      </th>

      <th [pSortableColumn]="'featureType'">
        <p-sortIcon [field]="'featureType'"></p-sortIcon>Category
      </th>

      <th [pSortableColumn]="'title'">
        <p-sortIcon [field]="'title'"></p-sortIcon>Headline
      </th>

      <th [pSortableColumn]="'featureDesc'">
        <p-sortIcon [field]="'featureDesc'"></p-sortIcon>Description
      </th>

      <th [pSortableColumn]="'highlight'">
        <p-sortIcon [field]="'highlight'"></p-sortIcon>Highlight
      </th>

      <th [pSortableColumn]="'quantity'">
        <p-sortIcon [field]="'quantity'"></p-sortIcon>Quantity
      </th>
      <th [pSortableColumn]="'distance'">
        <p-sortIcon [field]="'distance'"></p-sortIcon>Distance
      </th>
      <th [pSortableColumn]="'distanceUnit'">
        <p-sortIcon [field]="'distanceUnit'"></p-sortIcon>Distance Unit
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-feature>
    <tr [pSelectableRow]="feature">
      <td>{{feature.featureId}}</td>
      <td>
        <table>
          <tr>
            <td style="min-width:10px;">@if (feature.kbmMap) {
              <span style="color:blue;"><b>K</b></span>
            }
          </td>
          <td style="min-width:10px;">@if (feature.vrboMap) {
            <span style="color:red;"><b>V</b></span>
          }
        </td>
        <td style="min-width:10px;">@if (feature.rentalsUnitedMap) {
          <span
            style="color:green;"><b>O</b></span>
          }</td>
        </tr>
      </table>
    </td>

    <td>
      <p-inputSwitch (onChange)="onStatusChange($event,feature)" [(ngModel)]="feature.status"></p-inputSwitch>
    </td>

    <!--<td>{{trimFeatureType(feature.featureType)}}</td>
    <td>{{feature.describesType}}</td>-->

    <td>{{feature.name || trimFeatureType(feature.featureType) || '—'}}</td>
    <td [pEditableColumn]="feature" [pEditableColumnField]="'title'">
      <p-cellEditor>
        <ng-template pTemplate="input">
          @if (feature.status) {
            <input pInputText type="text" [(ngModel)]="feature.title">
          }
        </ng-template>
        <ng-template pTemplate="output">
          @if (feature.status&&!feature.title) {
            <span style="color:lightskyblue;font-size:small">add
            headline</span>
          }
          @if (feature.title&&feature.title.length<=20) {
            <span>{{feature.title}}</span>
          }
          @if (feature.title&&feature.title.length>20) {
            <span>{{feature.title.substring(0,20)}}
            ...</span>
          }
        </ng-template>
      </p-cellEditor>
    </td>

    <td [pEditableColumn]="feature" [pEditableColumnField]="'featureDesc'">
      <p-cellEditor>
        <ng-template pTemplate="input">
          @if (feature.status) {
            <textarea pInputTextArea type="text" [(ngModel)]="feature.featureDesc"
            rows="10" cols="50"></textarea>
          }
        </ng-template>
        <ng-template pTemplate="output">
          @if (feature.status&&!feature.featureDesc) {
            <span
            style="color:lightskyblue;font-size:small">add description</span>
          }
          @if (feature.featureDesc&&feature.featureDesc.length<=20) {
            <span>{{feature.featureDesc}}</span>
          }
          @if (feature.featureDesc&&feature.featureDesc.length>20) {
            <span
            >{{feature.featureDesc.substring(0,20)}}...</span>
          }

        </ng-template>
      </p-cellEditor>
    </td>

    <td [pEditableColumn]="feature" [pEditableColumnField]="'highlight'">
      <p-cellEditor>
        <ng-template pTemplate="input">
          <p-dropdown appendTo="body" [options]="highlights" [(ngModel)]="feature.highlight"
            optionLabel="name" optionValue="value">
          </p-dropdown>
        </ng-template>
        <ng-template pTemplate="output">
          @if (feature.status&&!feature.highlight) {
            <span style="color:lightskyblue;font-size:small">add
            highlight</span>
          }
          @if (feature.highlight) {
            <span>
              {{getHightlightName(feature.highlight)}}
            </span>
          }
        </ng-template>
      </p-cellEditor>
    </td>

    <td [pEditableColumn]="feature" [pEditableColumnField]="'quantity'">
      <p-cellEditor>
        <ng-template pTemplate="input">
          @if (feature.status) {
            <input pInputText type="text" [(ngModel)]="feature.quantity">
          }
        </ng-template>
        <ng-template pTemplate="output">
          @if (feature.status&&!feature.quantity) {
            <span style="color:lightskyblue;font-size:small">add
            quantity</span>
          }
          @if (feature.quantity) {
            <span>{{feature.quantity}}</span>
          }
        </ng-template>
      </p-cellEditor>
    </td>

    <td [pEditableColumn]="feature" [pEditableColumnField]="'distance'">
      <p-cellEditor>
        <ng-template pTemplate="input">
          @if (feature.status) {
            <input pInputText type="text" [(ngModel)]="feature.distance">
          }
        </ng-template>
        <ng-template pTemplate="output">
          @if (feature.status&&!feature.distance) {
            <span style="color:lightskyblue;font-size:small">add
            distance</span>
          }
          @if (feature.distance) {
            <span>{{feature?.distance}}</span>
          }
        </ng-template>
      </p-cellEditor>
    </td>

    <td [pEditableColumn]="feature" [pEditableColumnField]="'distanceUnit'">
      <p-cellEditor>
        <ng-template pTemplate="input">
          @if (feature.status) {
            <p-dropdown appendTo="body" [options]="distanceUnits"
              [(ngModel)]="feature.distanceUnit" optionLabel="name" optionValue="value">
            </p-dropdown>
          }
        </ng-template>
        <ng-template pTemplate="output">
          @if (feature.status&&!feature.distanceUnit) {
            <span
            style="color:lightskyblue;font-size:small">add distance type</span>
          }
          @if (feature.distanceUnit) {
            <span>{{getDistanceUnitName(feature?.distanceUnit)}}</span>
          }
        </ng-template>
      </p-cellEditor>
    </td>
  </tr>
</ng-template>

<ng-template pTemplate="paginatorCenter"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} -
  {{recordTotal> 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows +
lazyLoadEvent.first) : recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}} </ng-template>
</p-table>